export function progress_upload(state = 0, action) {
  if (action.type === 'SET_PROGRESS_UPLOAD') {
    return action.percent;
  }
  return state;
}
